import { render, staticRenderFns } from "./CustomerTickets.vue?vue&type=template&id=d9b4a342&scoped=true&"
import script from "./CustomerTickets.vue?vue&type=script&lang=js&"
export * from "./CustomerTickets.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTickets.vue?vue&type=style&index=0&id=d9b4a342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b4a342",
  null
  
)

export default component.exports